// constants/breeds.js
export const BREED_ALL = 'ALL';
